<template>
  <!-- <v-alert border="right" colored-border type="info" elevation="2">
    {{ message }}
  </v-alert> -->
  <!-- <v-card>
    <v-skeleton-loader
      class="mb-6"
      boilerplate
      elevation="2"
      type="list-item-avatar, list-item-three-line, card-heading"
    />
  </v-card> -->
  <!-- <v-icon x-large>mdi-delete-empty-outline</v-icon>
      <v-icon x-large>mdi-timer-sand-empty</v-icon>
      <v-icon x-large>mdi-delete-empty</v-icon> -->
  <v-card class="text-center mx-auto" max-width="500px">
    <v-card-text class="pb-0">
      <v-icon x-large style="font-size: 4rem">{{ icon }}</v-icon>
    </v-card-text>
    <v-card-title class="justify-center py-1" v-if="title">
      {{ title }}
    </v-card-title>
    <v-card-text>
      {{ message }}
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: [String, Boolean],
      required: false
    },
    message: {
      type: String,
      default: 'Nothing to see'
    },
    icon: {
      type: String,
      default: 'mdi-mailbox-open-up-outline'
    }
  }
}
</script>
